import _ from "lodash";

const pitchCounts = _.map(
  [
    10,
    25,
    50,
    100,
    150,
    200,
    250,
    300,
    400,
    500,
    750,
    1000,
    1250,
    1500,
    2000,
    2250,
    2500,
    5000,
    10000
  ],
  pitchCount => ({
    label: `${pitchCount.toLocaleString()} pitches`,
    value: pitchCount
  })
);

export default pitchCounts;



// WEBPACK FOOTER //
// ./src/constants/pitchCountOptions.js